import type { MessageSchema } from '.';

const messages: MessageSchema = {
	selected_reservation_date: 'Date de réservation sélectionnée',
	change_date: 'Modifier la date',
	reserve_with_voucher: 'Réserver avec un code voucher',
	redeem_your_vouchers_here: 'Échangez vos bons ici !',
	redeem_your_vouchers_and_gift_vouchers_during_payment_step:
		'Entrez vos codes de voucher uniques ci-dessous. Les cartes cadeaux peuvent être utilisées lors du paiement.',
	cancel: 'Annuler',
	redeem: 'Échanger',
	voucher_code: 'Code du bon',
	from: 'À partir de',
	per_person_short: 'p.p.',
	starting_from_short: 'à partir de',
	unable_to_redeem_voucher: "Impossible d'échanger le bon",
	view: 'Voir',
	book: 'Réserver',
	ok: 'OK',
	more_info: "Plus d'infos",
	swimwear_day: 'Jour de maillot de bain',
	filter_swimwear_days: 'Filtrer sur les jours de maillot de bain',
	add_extra_voucher: 'Ajouter un bon supplémentaire',
	make_your_choice: 'Faites votre choix',
	choose_from_options: 'Vous pouvez choisir parmi {count} options',
	unavailable_in_active_locale_message: 'Attention : Vous serez redirigé vers notre site web en anglais.',
	loading: 'Chargement',
	reserve_with_bathcard: 'Réserver avec carte de bain',
	i_have_a_gift_voucher: "J'ai un chèque-cadeau",
	back: 'Retour',
	close: 'Fermer',
	more_information: "Plus d'informations",
	view_page: 'Voir la page',
	choose: 'Choisir',
	go_back: 'Retour',
	previous_option: 'Option précédente',
	next_option: 'Option suivante',
	arrangements_and_deals: 'Forfaits & offres',
	choose_date: 'Choisissez une date',
	clear_date: 'Supprimer la date',
	choose_arrival_date: "Choisissez une date d'arrivée",
	prices_per_person: 'Les prix sont par personne',
	prices_per_person_per_night: 'Les prix sont par personne et par nuit',
	availability_notice: 'Il y a encore de la disponibilité !',
};

export default messages;
